import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  styleUrls: ['./inventory-details.component.css']
})
export class InventoryDetailsComponent {
  checkingTakeInventory = false;
  takeInventoryChecked = false;
  takeInventoryAvailable: any;
  inventoryStatus: 'initial' | 'loading' | 'success' | 'failure' = 'initial';

  listProductData: any;
  wsPath: string | null = null;
  wsPath2: string | null = null;
  wsPathData: any;
  wsPath2Data: any;
  loadingWsPath = false;
  loadingWsPath2 = false;
  loadingListProduct = false;
  constructor(private http: HttpClient, private clipboard: Clipboard) {}

  get inventoryButtonText() {
    switch (this.inventoryStatus) {
      case 'loading': return 'Loading Inventory Details...';
      case 'success': return 'Inventory Details Loaded';
      case 'failure': return 'Inventory Details Loading Failed';
      default: return 'Load Inventory Details';
    }
  }


  get inventoryButtonClass() {
    switch (this.inventoryStatus) {
      case 'success': return 'btn-success';
      case 'failure': return 'btn-failure';
      case 'loading': return 'btn-loading';
      default: return '';
    }
  }

  checkTakeInventory() {
    this.inventoryStatus = 'loading';
    this.checkingTakeInventory = true;
    this.takeInventoryChecked = false;
    fetch(`${environment.baseUrl}/takeInventory`, {
      headers: { 'x-api-key': environment.apiKey }
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          this.takeInventoryAvailable = data.length > 0;
        } else if (data && typeof data === 'object') {
          this.takeInventoryAvailable = Object.keys(data).length > 0;
        } else {
          this.takeInventoryAvailable = false;
        }
        this.takeInventoryChecked = true;
        this.inventoryStatus = 'success';
      })
      .catch(() => {
        this.takeInventoryAvailable = false;
        this.takeInventoryChecked = true;
        this.inventoryStatus = 'failure';
      })
      .finally(() => this.checkingTakeInventory = false);
  }

  async onFetchListProductClick(inventoryBtn: HTMLButtonElement) {
    await this.checkTakeInventory();
    this.fetchListProduct();
  }

  fetchListProduct() {
    this.loadingListProduct = true;
    fetch(`${environment.baseUrl}/listproduct`, {
      headers: { 'x-api-key': environment.apiKey }
    })
      .then(res => res.json())
      .then(data => {
        this.listProductData = data;
        if (data && data.filePath && typeof data.filePath === 'object') {
          this.wsPath = data.filePath.wsPath || null;
          this.wsPath2 = data.filePath.wsPath2 || null;
        } else {
          this.wsPath = null;
          this.wsPath2 = null;
        }
        this.wsPathData = null;
        this.wsPath2Data = null;
        console.log('wsPath:', this.wsPath, 'wsPath2:', this.wsPath2);
      })
      .finally(() => {
        this.loadingListProduct = false;
        this.fetchWsPath();
        this.fetchWsPath2();

      });
  }

  fetchWsPath() {
    if (!this.wsPath) return;
    this.loadingWsPath = true;
    fetch(`${environment.baseUrl}${this.wsPath}`, {
      headers: { 'x-api-key': environment.apiKey }
    })
      .then(res => res.text())
      .then(data => this.wsPathData = data)
      .catch(() => this.wsPathData = 'Error')
      .finally(() => this.loadingWsPath = false);
  }

  fetchWsPath2() {
    if (!this.wsPath2) return;
    this.loadingWsPath2 = true;
    fetch(`${environment.baseUrl}${this.wsPath2}`, {
      headers: { 'x-api-key': environment.apiKey }
    })
      .then(res => res.text())
      .then(data => this.wsPath2Data = data)
      .catch(() => this.wsPath2Data = 'Error')
      .finally(() => this.loadingWsPath2 = false);
  }
   copyHeroName(data) {
    this.clipboard.copy(data);
  }

  parseTable(data: any): any[] {
    if (!data) return [];
    if (Array.isArray(data)) return data;
    try {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
